/* eslint-disable react/prop-types */
import { useEffect, useState, useRef } from 'react'
import { gsap } from 'gsap'
import splash from './assets/abreAniversario.jpg'
import './style.scss'

const BTPOpening = ({ interval, cbFinished }) => {
    const [finished, setFinished] = useState(false)
    const [calendar, setCalendar] = useState('')
    const timing = useRef(interval * 1000)
    const timer = useRef(null)

    useEffect(() => {
        if (finished) {
            setFinished(false)
            cbFinished()
        }
    }, [cbFinished, finished])

    useEffect(() => {
        timer.current = window.setInterval(
            () => setFinished(true),
            timing.current,
        )
        return () => window.clearInterval(timer.current)
    }, [])

    useEffect(() => {
        const now = new Date()
        const d = `${now.getDate()}`.padStart(2, '0')
        const M = `${now.getMonth() + 1}`.padStart(2, '0')
        setCalendar(`${d}/${M}`)
    }, [])

    useEffect(() => {
        const master = gsap.timeline({ defaults: { duration: 1 } })
        master.from('.dia', { opacity: 0 }, '+=1')
    }, [])

    return (
        <>
            <img className='splash' src={splash} alt='' />
            <div className='dia'>{calendar}</div>
        </>
    )
}

export default BTPOpening
